export default __webpack_public_path__ + "static/media/english-to-finnish-screenshot-04.5c407cb4.png";